<template>
  <CustomersComponent />
</template>

<script>
// @ is an alias to /src
import CustomersComponent from "@/sections/voiceplus/components/CustomersComponent.vue";
import config from "@/config";

export default {
  name: "Customers",
  components: {
    CustomersComponent,
  },
  data: function () {
    return {
      sections: config.Sites,
    };
  },
};
</script>
